/* ==========================================================================
   MM-Product-Recommendations — Moon Moon Agency
   Charge les recommandations Search & Discovery via l'API JSON,
   puis fetch chaque carte via /products/{handle}?view=reco-card.
   ========================================================================== */

if (window.__mmProductRecoLoaded) {
	/* Script tag may be present several times when multiple sections instantiate it.
     Skip re-execution to avoid duplicate class declaration errors. */
} else {
	window.__mmProductRecoLoaded = true;

	class MMProductRecommendations extends HTMLElement {
		connectedCallback() {
			if (this._initialized) return;
			this._initialized = true;

			const productId = this.dataset.productId;
			const list = this.querySelector(".mm-product-reco__grid");
			if (!productId || !list) return;

			const root = window.Shopify?.routes?.root || "/";

			list.classList.add("mm-product-reco__grid--loading");

			const intent = this.dataset.intent || "complementary";
			const limit = this.dataset.limit || 4;

			fetch(`${root}recommendations/products.json?product_id=${productId}&intent=${intent}&limit=${limit}`)
				.then((res) => {
					if (!res.ok) throw new Error(`HTTP ${res.status}`);
					return res.json();
				})
				.then(({ products }) => {
					if (!products || products.length === 0) {
						this.hidden = true;
						const titleEl = this.previousElementSibling;
						if (titleEl && titleEl.classList.contains("mm-product-reco__title")) {
							titleEl.hidden = true;
						}
						return;
					}

					const cardPromises = products.slice(0, parseInt(limit)).map((product) =>
						fetch(`${root}products/${product.handle}?view=reco-card`)
							.then((res) => {
								if (!res.ok) throw new Error(`HTTP ${res.status}`);
								return res.text();
							})
							.then((html) => {
								const temp = document.createElement("div");
								temp.innerHTML = html;
								const card = temp.querySelector(".mm-reco-card");
								if (!card) return null;

								return card;
							})
							.catch((e) => {
								window.log("warn", "🛍️ [PRODUCT_RECO]", "Card fetch failed", { handle: product.handle, error: e.message });
								return null;
							}),
					);

					Promise.all(cardPromises).then((cards) => {
						const validCards = cards.filter(Boolean);
						if (validCards.length === 0) {
							this.hidden = true;
							const titleEl = this.previousElementSibling;
							if (titleEl && titleEl.classList.contains("mm-product-reco__title")) {
								titleEl.hidden = true;
							}
							return;
						}

						list.innerHTML = "";
						validCards.forEach((card) => list.appendChild(card));

						this.removeAttribute("hidden");
						const titleEl = this.previousElementSibling;
						if (titleEl && titleEl.classList.contains("mm-product-reco__title")) {
							titleEl.removeAttribute("hidden");
						}

						list.classList.remove("mm-product-reco__grid--loading");

						if (typeof window.initAddToCartForms === "function") {
							window.initAddToCartForms();
						}

						if (typeof window.CardSwatchManager?.setup === "function") {
							window.CardSwatchManager.setup();
						}

						window.log("info", "🛍️ [PRODUCT_RECO]", "Recommendations loaded", { count: validCards.length });
					});
				})
				.catch((e) => {
					window.log("warn", "🛍️ [PRODUCT_RECO]", "Recommendations fetch failed", { error: e.message });
					list.classList.remove("mm-product-reco__grid--loading");
					this.hidden = true;
				});
		}
	}

	if (!customElements.get("product-recommendations")) {
		customElements.define("product-recommendations", MMProductRecommendations);
	}

	/* Init manuelle des éléments déjà dans le DOM au moment du chargement du script (defer) */
	document.querySelectorAll("product-recommendations").forEach((el) => {
		if (el instanceof MMProductRecommendations) {
			el.connectedCallback();
		} else {
			MMProductRecommendations.prototype.connectedCallback.call(el);
		}
	});
}
/* fin garde-fou contre double-load */
